<div >
  <div >
    <div>
      <span class="rejectcontent">
         <span>Once you reject, the application will be moved to the reject queue.
          Are you sure you want to reject the application? </span>
          <!-- Are you sure you want to mark this  {{resourceTypeLabel}} as rejected? -->
      </span>
    </div>
    <div class="rejectreason">
      <span>Reason for rejection</span>
    </div>
    <div style="margin-top: 10px;">
      <textarea name="" id="" rows="7" cols="70" required  #reasonRef="ngModel"  
                [(ngModel)]="rejectionReason" placeholder="Enter your reason here..."></textarea>

      <div *ngIf="reasonRef.invalid && reasonRef.touched" class="error-text">
        Enter Reason.
      </div>
    </div>
  
    <div style="margin-top: 32px;">
      <div class="flex justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-center m-2">
          <button class="btn-1 btn-warning-1 outlined-1 small raised" pButton
           (click)="onCancel()">Cancel</button>
        </div>
        <div class="flex align-items-center justify-content-center m-2">
          <button class="btn-1 btn-warning-2 outlined-1 small raised" pButton
          [disabled]="reasonRef.invalid"
           (click)="onReject()">Reject</button>
        </div>
      </div>
    </div>
  </div>
</div>
